import { render, staticRenderFns } from "./bilder.vue?vue&type=template&id=2b126718&"
import script from "./bilder.vue?vue&type=script&lang=js&"
export * from "./bilder.vue?vue&type=script&lang=js&"
import style0 from "./bilder.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports